/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PricingPolicyEnhancedApplyConditionType } from './PricingPolicyEnhancedApplyConditionType';

export type PricingPolicyEnhancedApplyFilterItem = ({
    filterType: PricingPolicyEnhancedApplyFilterItem.filterType;
    conditionType: PricingPolicyEnhancedApplyConditionType;
    value: Array<number>;
} | {
    filterType: PricingPolicyEnhancedApplyFilterItem.filterType;
    conditionType: PricingPolicyEnhancedApplyConditionType;
    value: Array<string>;
});

export namespace PricingPolicyEnhancedApplyFilterItem {

    export enum filterType {
        JOB_FAMILY = 'JOB_FAMILY',
    }


}

